import { LitElement, customElement, html } from 'lit-element';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 * @docs https://lit-element.polymer-project.org/
 */
@customElement('loading-indicator')
class LoadingComponent extends LitElement {
  static get properties() {
    return {
      value: { type: String },
      next_screen: { type: String },
    };
  }

  constructor() {
    super();
    this.value = '2312.00';
    this.next_screen = '';
  }

  render() {
    return html`
      <div class="chart-container">
        <div class="chart-card">
          <div class="chart-box">
            <div class="percent">
              <svg>
                <circle cx="140" cy="140" r="110"></circle>
                <circle cx="140" cy="140" r="110" id="filled-circle"></circle>
              </svg>
              <div class="number">
                <span class="chart-number-currency">CHF</span>
                <span>${this.value}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    let amountOfCalls = 0;
    const values = ['2312.00', '1492.00', '812.00', '553.00'];
    const _timerId = setInterval(() => {
      this.value = values[amountOfCalls];

      if (++amountOfCalls === 4) {
        // eslint-disable-line
        window.clearInterval(_timerId);
        this.kasko.dispatchEvent('go-forward');
      }
    }, 400);
  }

  createRenderRoot() {
    return this;
  }
}

export default LoadingComponent;
